import {SET_REFRESH_TOKEN} from '../actions/types';


const refreshToken = (state = null, action) => {
  switch (action.type) {
    case SET_REFRESH_TOKEN:
      return action.payload;
    default:
      return state;
  }
};

export default refreshToken;